import { info } from "daisyui/src/colors/colorNames";

function covertToDateValue(date) {
    if (!date) {
        return false;
    }
    const { year, month, day } = date;

    return `${year}/${month}/${day}`
}

function covertToDateCalender(value) {
    let splitValue = value.split("/")
    return {
        year: parseInt(splitValue[0]),
        month: parseInt(splitValue[1]),
        day: parseInt(splitValue[2]),
    }
}

function lenthTime(d1, d2) {
    return ((((new Date(d2) - new Date(d1)) / 1000) / 60) / 60) / 24
}

function splitNumber(e) {
    e.target.type = "text";

    let { value } = e.target;

    e.target.value = value && parseInt(value).toLocaleString()
}

function getNumber(e) {

    let { value } = e.target;

    let splitAndToJoinString = value.split(",").join("");

    e.target.type = "number";

    e.target.value = parseInt(splitAndToJoinString)
}

export { covertToDateCalender, covertToDateValue, lenthTime, getNumber, splitNumber }